import React from "react";
import { getTemporaryBlockId } from "../../../../../../../services/helpers/Helper";

const PhonePopover = (props) => {
   const { onChange, faqId, index, handleChangeButton } = props;
   let { button, buttons, data } = props;

   const onChangePhone = (e) => {
      if (handleChangeButton) {
         let value = e.target.value.replace(/\s+/g, '')
         if (!value.startsWith("+84")) {
            if (value.startsWith("0")) {
               value = value.substring(1);
            }
            value = "+84" + value;
         }
         buttons[index].action.value = value;
         handleChangeButton(buttons);
      }
   }

   const handleRemove = () => {
      if (handleChangeButton) {
         buttons = buttons.map((m, i) => i === index ? { title: m.title } : m);
         handleChangeButton(buttons);
      }
      if (onChange) {
         data.blocks = data.blocks.filter((f) => getTemporaryBlockId(f) !== getTemporaryBlockId(button.action));
         onChange(data);
      }
   }
   return (
      <React.Fragment>
         <div className="width100 mb10 mt76">
            <label className="text-smaller">Hành động khi nhấn nút:</label>
            <div className="card-button-editor-content-go-to-block btn btn-default block-display overflow-ellipsis button-action-pressed button-action-phone-pressed">
               <div className="width85 pl20 display-flex align-items-center">
                  <i className="fa ml5 mr15 font-size-23-i">
                     <svg ariaHidden="true" focusable="false" data-prefix="fas" data-icon="phone" className="svg-inline--fa fa-phone fa-w-16 " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                        <path fill="currentColor"
                           d="M493.4 24.6l-104-24c-11.3-2.6-22.9 3.3-27.5 13.9l-48 112c-4.2 9.8-1.4 21.3 6.9 28l60.6 49.6c-36 76.7-98.9 140.5-177.2 177.2l-49.6-60.6c-6.8-8.3-18.2-11.1-28-6.9l-112 48C3.9 366.5-2 378.1.6 389.4l24 104C27.1 504.2 36.7 512 48 512c256.1 0 464-207.5 464-464 0-11.2-7.7-20.9-18.6-23.4z">
                        </path>
                     </svg>
                  </i>
                  <span className="text-button-action text-overflow-ellipsis">Gọi điện thoại</span>
               </div>
               <div className="width15 button-action-remove" onClick={handleRemove}>
                  <a>
                     <svg ariaHidden="true" focusable="false" data-prefix="fas" data-icon="times" className="svg-inline--fa fa-times fa-w-11 text-bigger" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 352 512">
                        <path fill="currentColor"
                           d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z">
                        </path>
                     </svg>
                  </a>
               </div>
            </div>
            <div className="width100 mt15 mb5 input-phone-number-wrapper">
               <label>Số điện thoại</label>
               <div className="phone-number-warning">
                  Hiện Facebook chưa hỗ trợ gọi số tổng đài 1900, 1800.. tại Việt Nam. Quý khách nên sử dụng số điện thoại di động.
               </div>
               <div className="input-phone-number-container ">
                  <div className="input-select text-smallest">
                     <select className="">
                        <option value="+" selected="">+</option>
                        <option value="1+">1+</option>
                        <option value="2+">2+</option>
                        <option value="3+">3+</option>
                        <option value="4+">4+</option>
                        <option value="5+">5+</option>
                        <option value="6+">6+</option>
                        <option value="7+">7+</option>
                        <option value="8+">8+</option>
                        <option value="9+">9+</option>
                     </select>
                     <div className="svg-next-icon ic-arrow-down">
                     </div>
                  </div>
                  <div className="input-phone-number-separate">
                     <div>

                     </div>
                  </div>
                  <div className="input-text input-text-none-scrollbar text-single font-size-14 input-phone-number border-none-a">
                     <input type="text" value={button?.action?.value} onChange={onChangePhone} />
                  </div>
               </div>
            </div>
         </div>
      </React.Fragment>
   )
}

export default PhonePopover;